import { GetterTree } from 'vuex';
import { RootState, UserState } from '../types';

const getters: GetterTree<UserState, RootState> = {

};

export default getters;
